import React, {useContext} from "react";
import {Link, useHistory} from "react-router-dom";

import LanguageChooser from "./LanguageChooser";
import ScrollContext from "../../library/ScrollContext";

const footerVisible = (scrollPos) =>
    window.innerHeight >= document.documentElement.scrollHeight ||
    scrollPos + window.innerHeight < document.documentElement.scrollHeight - 30;

const introVisible = (_scrollPos) => {
    const nodes = document.querySelectorAll(".text_container");
    if (!nodes.length) return false;

    const threshold = 60; // px from top of viewport

    return Array.from(nodes).some((el) => {
        const rect = el.getBoundingClientRect();
        const reachedThreshold = rect.top <= threshold;
        const notFullyExited = rect.bottom > 0; // still at least partly in view
        return reachedThreshold && notFullyExited;
    });
};

const TopNavigation = ({setOverlayActive, goHome = false}) => {
    const history = useHistory();
    const {scrollPos} = useContext(ScrollContext);

    return (
        <div className={`nav_container 
        ${ !footerVisible(scrollPos) ? "footer" : "" }
        ${ introVisible(scrollPos) ? "introVisible" : "" }
        `}>
            <div className="left">
                <div className="desk_nav_home p btn square white" onMouseOver={() => setOverlayActive(true)} onMouseOut={() => setOverlayActive(false)} onClick={() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                    if (goHome) history.push("/");
                }}>
                    <span>Studio Flux</span>
                </div>

                <Link to={{
                    pathname: "/info",
                    state: {fromPage: history.location.pathname},
                }} className="desk_nav_info p btn trans white">
                    <span>I</span>
                    <span>nformation</span>
                </Link>

            </div>
            <div className="right">
                {/*<Link*/}
                {/*    to={{*/}
                {/*        pathname: "/info",*/}
                {/*        state: { fromPage: history.location.pathname },*/}
                {/*    }}*/}
                {/*    className="desk_nav_index"*/}
                {/*>*/}
                {/*    <span>I</span>*/}
                {/*    <span>nfo</span>*/}
                {/*</Link>*/}
                <LanguageChooser/>
            </div>
        </div>
    );
};

export default TopNavigation;
